import { customElement, bindable, useView, bindingMode, autoinject, containerless, PLATFORM } from 'aurelia-framework';
import { InputBase } from '../inputBase';

@customElement('ex-loader')
@useView(PLATFORM.moduleName('./control.html'))
@autoinject()
export class Loader{

}
